import React, {Component} from "react";
import {connect} from "react-redux";
import {DatePicker, List, Picker, Toast} from "antd-mobile";
import './RosterApply.css';
import {API} from "../../../configs/api.config";
import {Button} from "antd";
import {getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";
import {fetchGet, fetchPost} from "../../../utils/fetchRequest";
import ClassBean from "../../../model/ClassBean";

class RosterApply extends Component {
    componentWillMount() {
        document.title = "添加家长信息";
    }

    componentDidMount() {
        this.node.scrollIntoView();
        this.getOrganization()
    }

    constructor(props) {
        super(props);
        this.state = {
            gradeClazz: this.props.match.params.gradeClazz,
            clazzId: this.props.match.params.clazzId,
            schoolId: this.props.match.params.schoolId,
            classList: [],
            classValue: [],
            stuName: null, // 学生名字
            stuBean: null, // 学生名字
            relation: null, // 关系
            parentsName: null, // 家长姓名
            paPhone: null, // 关系
            stuId: null, // 关系
            stuState: false,
            isClickable: true
        };
    }

    render() {
        const {
            gradeClazz, classList, classValue, isClickable
        } = this.state;

        return (
            <div className="common-column-layout" ref={node => this.node = node} onChange={this.handelValueCom} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
                <div className='headerLayout'>可以把此链接发给家长自行添加关注公众号号码</div>
                {/*<Picker data={classList} title='选择班级' extra='请选择'
                        value={classValue} onChange={this.handleClassChange} cols={1}>
                    <List.Item arrow="horizontal">选择班级</List.Item>
                </Picker>*/}
                <div className="item_sty">
                    <div className="left_title">班级</div>
                    <input ref='gradeClazz' className="text-right right_input" type="text" readonly="readonly" maxLength={20} autoFocus="autoFocus" value={this.state.gradeClazz}/>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">输入学生姓名</div>
                </div>
                <div className="item_sty">
                    <input ref='stuName' className="left_title" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.stuName}/>
                    <div className="right_button"><Button onClick={this.onButtonClick}>查询</Button></div>
                </div>

                <div className="comhline_sty"></div>

                {/*<div>
                    <textarea  ref='faultReason' className="form-control textarea_sty" rows="4"
                               placeholder="家长信息" maxLength={100}></textarea>
                </div>*/}
                {this.state.stuState?(
                <div className="common-column-layout"  ref={node => this.node = node} onChange={this.handelValueCom1} style={{fontFamily:"PingFangSC-Regular",letterSpacing:2.5}}>
                    <div className="comhline_sty1"></div>
                    <div className="item_sty">
                        <div className="left_title"></div>
                        <input ref='stuBean' className="right_input" type="text" readOnly="readonly"
                               maxLength={20} autoFocus="autoFocus" value={'学生'+this.state.stuBean+'的家长信息绑定'}/>
                    </div>

                <div className="item_sty">
                    <div className="left_title">关系</div>
                   {/* <select className="text-right right_input">
                        <button>父子</button>
                        <button>母子</button>
                        <button>兄弟</button>
                        <button>兄妹</button>
                        <button>姐弟</button>
                        <button>姐妹</button>
                        <button>祖孙</button>
                        <button>其他</button>
                    </select>*/}
                    <input ref='relation' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.relation}/>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">姓名</div>
                    <input ref='parentsName' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.parentsName}/>
                </div>

                <div className="comhline_sty1"></div>

                <div className="item_sty">
                    <div className="left_title">电话</div>
                    <input ref='paPhone' className="text-right right_input" type="text" placeholder="请输入" maxLength={20} autoFocus="autoFocus" value={this.state.paPhone}/>
                </div>

                <div className="comhline_sty1"></div>

                <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30}}
                        onClick={this.onSubmitClick} disabled={!this.state.isClickable}>提交</Button>
                </div>):""}
            </div>
        )
    }

    handleClassChange = (v) => {
        this.setState({classValue: v})
    }

    onButtonClick = (event) => {
        const {
            classList, classValue, gradeClazz, clazzId
        } = this.state;

        if (gradeClazz == null || gradeClazz == '') {
            Toast.fail('年级班级不存在！')
            return
        }

        if (this.state.stuName == null || this.state.stuName.trim().length == 0) {
            Toast.show('请填写学生姓名',1);
            return
        }

        const params = {
            stuName: this.state.stuName,
            classId: clazzId,
        };

        console.log('param', params);
        fetchGet(API.GET_ROSTER_NAME, params).then((response) => {
            if (response.success) {
                // Toast.show(response.data, 1);stu
                this.setState({
                    stuBean: response.data[0].stuName,
                    stuId: response.data[0].stuId,
                    stuState: true
                })
            }else{
                Toast.fail(response.message, 2)
            }
        }).catch((error) => {
            console.log('error', error);
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('学生不存在，请与班主任确认学生姓名是否有误', 2)
            }
        })
    };

    onSubmitClick = (event) => {
        const {
            schoolId
        } = this.state;
        this.setState({ isClickable: false })
        const promise = new Promise((resolve, reject) => {
              setTimeout(resolve, 3000)
        })

        promise.then(() => {
          this.setState({ isClickable: true })
        })
        if (this.state.relation == null || this.state.relation == '') {
            Toast.fail('请填写您和学生的关系')
            return
        }

        if (this.state.parentsName == null || this.state.parentsName.trim().length == 0) {
            Toast.show('请填写家长姓名',1);
            return
        }

        if (this.state.paPhone == null || this.state.paPhone.trim().length == 0) {
            Toast.show('请填写家长电话',1);
            return
        }

        const params = {
            relation: this.state.relation,
            parentsName: this.state.parentsName,
            paPhone: this.state.paPhone,
            stuId: this.state.stuId,
            schoolId: schoolId,
        };

        fetchPost(API.BINDING_STUNAME, params).then((response) => {
            console.log('response', response);
            if (response.success) {
                // Toast.show(response.data, 1);
                Toast.show(response.data)
            }else{
                Toast.fail(response.message,2)
            }
        }).catch((error) => {

            console.log('error', error);
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    };

    getOrganization = () => {
        const {classList, classValue} = this.state
        classList.length = 0

        let url = API.GET_SCHOOL_LIST
        let params = {
            schoolId: this.state.schoolId,
            teacherId: this.props.userInfo.user.userFunId
        }
        fetchGet(url, params).then(response => {
            Toast.hide()
            this.analysisClassList(response)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('班级获取异常', 2)
            }
        })
    };

    analysisClassList = response => {
        const {classList, classValue} = this.state
        classList.length = 0
        classValue.length = 0

        let dataArray = response.data
        if (dataArray) {
            for (let i = 0; i < dataArray.length; i++) {
                let dataObject = dataArray[i]
                if (dataObject) {
                    let classBean = new ClassBean()

                    classBean.label = getStrValue(dataObject, 'gradeName') + getStrValue(dataObject, 'clazzName')
                    classBean.value = i
                    classBean.schId = getStrValue(dataObject, 'clazzId')
                    classBean.parentId = getStrValue(dataObject, 'gradeId')
                    classBean.schName = getStrValue(dataObject, 'clazzName')
                    classBean.schStatus = getStrValue(dataObject, 'clazzStatus')
                    classBean.schRemarks = getStrValue(dataObject, 'clazzRemarks')
                    classBean.grade = getStrValue(dataObject, 'gradeName')

                    classList.push(classBean)
                }
            }

            if (classList.length > 0) {
                classValue.push(classList[0].value)
                this.setState({
                    classList,
                    classValue
                })
            }
        }
    }

    handelValueCom = (event) => {
        //获取用户名的值
        let stuName = this.refs.stuName.value;
        //获得内容的值
        this.setState({
            stuName: stuName,
        })
    }

    handelValueCom1 = (event) => {
        //获取用户名的值
        let relation = this.refs.relation.value;
        let parentsName = this.refs.parentsName.value;
        let paPhone = this.refs.paPhone.value;
        //获得内容的值
        this.setState({
            relation: relation,
            parentsName: parentsName,
            paPhone: paPhone,
        })
    }

}
let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RosterApply)